import { Button, Result, Typography } from "antd";
import { useNavigate } from "react-router-dom";

export const PageComingSoon = () => {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="Page is Coming Soon"
      subTitle={
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography.Text
              style={{
                fontSize: 16,
                fontWeight: 500,
                paddingTop: 20,
                marginBottom: 20,
              }}
            >
              Please Contact{" "}
              <Typography.Link
                style={{ fontSize: 20 }}
                target="_blank"
                href="https://kpmg.com/sg/en/home/contacts/c/deven-chhaya.html"
              >
                Deven Chhaya - KPMG Singapore
              </Typography.Link>
            </Typography.Text>
          </div>
        </>
      }
      extra={
        <Button
          type="primary"
          onClick={() => navigate("/dashboard#esg-hub", { replace: true })}
        >
          Back Home
        </Button>
      }
    />
  );
};
